import { AuthDataStatus } from "../../../_statics/AuthDataStatus";
import { AuthDataIdentifier, AuthDataType, isShopifyAppstoreAppType } from "../../../_statics/AuthDataType";
import dateUtils from "../../../_services/date-utils";

const SETUP_GRACE_PERIOD_MS = 1000 * 60 * 10;

export const connectionStatusSeverity = (status) => {
    if (status === AuthDataStatus.REVOKED) {
        return "error";
    }
    if (status === AuthDataStatus.SETUP || status === AuthDataStatus.EXPIRED || status === AuthDataStatus.INVALID) {
        return "warning";
    }
    return "ok";
};

export const isShopifyAppstoreConnection = (connection) => isShopifyAppstoreAppType(connection.type);

// A Shopify OAuth connection goes EXPIRED when Shopify rejects its refresh token; only the merchant can repair
// it by opening the app again from the Shopify admin (issue #41971).
export const isExpiredShopifyConnection = (connection) =>
    connection.status === AuthDataStatus.EXPIRED && isShopifyAppstoreConnection(connection);

// INVALID = Shopify rejected the credential on import (401) or on the legacy-to-OAuth token exchange (issue
// #41971); same remedy as EXPIRED — the merchant has to reopen the app in Shopify.
export const isInvalidShopifyConnection = (connection) =>
    connection.status === AuthDataStatus.INVALID && isShopifyAppstoreConnection(connection);

// A legacy (non-_V2) Shopify appstore credential that still works, i.e. the only kind the manual "Migrieren"
// action can exchange for an expiring token pair (issue #41971); anything else is already migrated or needs the
// merchant to reopen the app.
export const isLegacyShopifyConnection = (connection) =>
    connection.status === AuthDataStatus.VALID &&
    [AuthDataIdentifier.SHOPIFY_APPSTORE_PLATFORM, AuthDataIdentifier.SHOPIFY_APPSTORE_BILLING].includes(
        connection.type
    );

const msSinceCreation = (connection) => dateUtils.getDurationBetweenInMs(new Date(connection.createdAt), new Date());

export const isAwaitingSetup = (connection) =>
    connection.status === AuthDataStatus.SETUP &&
    (!connection.createdAt || msSinceCreation(connection) < SETUP_GRACE_PERIOD_MS);

// PayPal is the only integration that leaves a setup hanging rather than failing it,
// so a stalled one has to be told apart from one that is merely still running.
export const isStalledPaypalSetup = (connection) =>
    connection.status === AuthDataStatus.SETUP &&
    connection.type === AuthDataType.PAYPAL.identifier &&
    !!connection.createdAt &&
    msSinceCreation(connection) >= SETUP_GRACE_PERIOD_MS;
